import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Typography, Avatar } from "@mui/material";
import { MdKeyboardArrowDown } from "react-icons/md";
import IconButton from "@material-ui/core/IconButton";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { BsDot } from "react-icons/bs";
import like from "src/Assets/images/like.svg";
import unlike from "src/Assets/images/unlike.svg";
import Edit from "src/Assets/images/edit.svg";
import dot from "src/Assets/images/dot.png";
import Delete from "src/Assets/images/Delete.svg";
import activityStyle from "src/Assets/css/Activity/activity.module.css";
import Location from "src/Assets/images/locationpin.png";
import API from "src/network";
import ReusuableSendaMailModal from "src/Modules/Reusuablecomponents/ReusuableSendaMailModal";
import ReusuableReportDialogmodal from "src/Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import SimpleDialogDemo from "src/Modules/Reusuablecomponents/CustomizedDialogs";
import PostMessageValidation from "src/Modules/Reusuablecomponents/PostMessageValidation";
import PopupComponent from "./PopupComponent";
import AvatarBadge from "src/Components/AvatarBadge";
import ReusuableDeleteDialogmodal from "src/Modules/Reusuablecomponents/ReusuableDeleteModal";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import MapDialog from "../../../../pages/HomePage/components/LocationAddress";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import { PiDotsThreeBold } from "react-icons/pi";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";

function SaysActivityUI(props) {
  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const [editId, setEditID] = useState(null);
  const [popupPostId, setPopPostId] = useState(null);
  const [parentAskId, setParentAskId] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);

  const {
    updateEditPostId,
    deleteAnswersOnParentAskDelete,
    handleDeleteAttachementDoc,
    isAttacmentDeleted,
    setIsAttacmentDeleted
  } = props;

  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });

  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const followunfollowCallback = (id, followStatus, followCount) => {
    console.log(`followCount new,,,:`, followCount);
    const newStatus = followCount === "1" ? "N" : "Y";
    const newPopupDataList = popupData.childQ.map((item) => {
      if (item.id === id) {
        const newFollowCount =
          followCount === "1" ? item.followCount - 1 : item.followCount + 1;
        return {
          ...item,
          followStatus: newStatus,
          followCount: newFollowCount,
        };
      } else {
        return item;
      }
    });
    setPopupData((prevData) => ({ ...prevData, childQ: newPopupDataList }));
    API.fetchFollowUnfollowData(id, followStatus);
  };

  const followunfollow = (id, followStatus, followCount) => {
    if (followCount === "1") {
      // show confirmation popup before unfollow
      setShowUnfollowAlert({ id, followStatus, followCount });
    } else {
      // directly follow (no popup)
      followunfollowCallback(id, followStatus, followCount);
    }
  };

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  const onLikeUnlikeSelection = (id, cache) => {
    props.likeUnlike(id);
    API.fetchVoteUpStatus(id, cache);
  };

  const updateMessage = (id, message, locationName, attachment, lat, lng) => {
    props.updateMessage && props.updateMessage(id, message, locationName, attachment, lat, lng);
    setEditID(null);
  };

  const deletePopupMessage = async (id) => {
    try {
      const formdata = new FormData();
      formdata.append("messageID", id);
      await API.deleteAskTagPostUnderSayActivity(formdata);
      if (popupData?.childQ && Array.isArray(popupData.childQ)) {
        const newPopupDataList = popupData.childQ.filter(
          (item) => item.id !== id,
        );
        setPopupData((prevData) => ({ ...prevData, childQ: newPopupDataList }));
      } else {
        setPopupData(null);
      }
      onClosePopup();
      if (deleteAnswersOnParentAskDelete) {
        deleteAnswersOnParentAskDelete(parentAskId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickHashTag = async (parentId, id) => {
    try {
      const formData = new FormData();
      formData.append("id", parentId);
      formData.append("openQstatus", "SAYsQchild4");
      formData.append("mostlikedrepabuse", "mostliked");
      formData.append("parantId", "mostliked");
      const response = await API.getChildHashTag(formData);
      setPopupData(response.data); // Set the response data in state
      setOpen(true);
      setPopPostId(id);
      setParentAskId(parentId);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onClosePopup = () => {
    setOpen(false);
    setPopPostId(null);
  };

  const cancelEdit = () => {
    props?.removeNewSelectedLocationKey && props?.removeNewSelectedLocationKey();
    setEditID(null);
  };

  const truncateLocationName = (locationName, newSelectedLocation) => {
    const maxLength = 30; // Set your desired max length
    const nameToDisplay = newSelectedLocation || locationName;

    if (nameToDisplay.length > maxLength) {
      return nameToDisplay.substring(0, maxLength) + "...";
    } else {
      return nameToDisplay;
    }
  };

  console.log(`props.listData for answers:`, props.listData);

  return (
    <>
      {props.listData.map((result) => (
        <div className={activityStyle.activityPostCard} key={result.id}>
          <div className="profile-info">
            <div
              className={activityStyle.activityPostImageDropdownMainContainer}
            >
              <div className={activityStyle.activityPostImageProfileContainer}>
                <div className={activityStyle.profileimg}>
                  <div className={feedstyles.avatarContainer}>
                    <AvatarBadge
                      src={`${profileImagePath}${result?.mainuserdata?.uimage}`}
                      alt={result?.mainuserdata?.displayName}
                      isPrimaryModerator={result?.mainuserdata?.isPM == 1}
                      isModerator={
                        result?.mainuserdata?.isModerator == 1 &&
                        result?.mainuserdata?.isPM == 0
                      }
                    />
                    <ProfileHoverCard
                      result={result}
                      isActionDisabled={props.isActionDisabled}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }} className={activityStyle.profilename}>
                  <span
                    className={feedstyles.profilename}
                    style={{ display: "flex" }}
                  >
                    <p className={feedstyles.profilehovername}>
                      {result?.mainuserdata?.displayName}
                    </p>
                    {result?.mainuserdata?.isImpactableMember === "yes" && (
                      <img
                        src={alreadyImpactfulMemberImg}
                        alt="Impactful Member"
                        title="Impactful Member"
                        style={{
                          width: "18px",
                          height: "18px",
                          objectFit: "contain",
                          flexShrink: 0,
                          marginLeft: "-4px",
                        }}
                      />
                    )}
                  </span>
                  <div className={activityStyle.timeLocationContainer}>
                    <span
                      className={
                        result.locName
                          ? activityStyle.tenantAndTimeName
                          : activityStyle.tenantAndTimeNameWithoutLocation
                      }
                    >
                      {result.Message_Time}{" "}
                      {result.edited === 1 && (
                        <span> (edited {result.updated_time})</span>
                      )}{" "}
                      in {result.Tenant_name}{" "}
                    </span>
                    {(result.locName || result.newSelectedLocation) && (
                      <span className={activityStyle.locationContainer}>
                        <img
                          src={dot}
                          alt="dot"
                          className={activityStyle.dotImg}
                        />
                        <img
                          src={Location}
                          alt=""
                          className={activityStyle.locationIconImg}
                          onClick={() =>
                            handleClickOpen(
                              result.locName,
                              result.msgLat,
                              result.msgLng,
                            )
                          }
                        />
                        <span
                          className={activityStyle.locationContent}
                          onClick={() =>
                            handleClickOpen(
                              result.locName,
                              result.msgLat,
                              result.msgLng,
                            )
                          }
                        >
                          {truncateLocationName(
                            result.locName,
                            result.newSelectedLocation,
                          )}
                        </span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={
                  activityStyle.activityPostCardImagePopupMainContainer
                }
              >
                <Menu portal={true} viewScroll="close" position="anchor" reposition="auto"
                  menuButton={
                    <IconButton
                      style={{
                        padding: 0,
                        width: 30,
                        height: 30,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        outline: "none",
                      }}
                      disabled={
                        result.communityFollowStatus === 0 &&
                        result.tenantType === "private"
                      }
                    >
                      {/* <MdKeyboardArrowDown fontSize={25} /> */}
                      <PiDotsThreeBold
                        fontSize={25}
                        color="rgba(0, 0, 0, 0.7)"
                      />
                    </IconButton>
                  }
                  transition
                  direction="bottom"
                  arrow
                  menuStyle={{
                    backgroundColor: "white",
                    borderRadius: 20,
                  }}
                  align="end"
                >
                  {result.userDetails.User_ID !==
                  userDetails.userData.User_ID ? (
                    <>
                      {result.moderatorStatus === "1" ? (
                        <>
                          <MenuItem>
                            <ReusuableDeleteDialogmodal
                              label={"Delete Post"}
                              type={props?.postType}
                              id={result.id}
                              deleteMessage={() =>
                                props?.onDelete && props.onDelete(result.id)
                              }
                              fetchContributors={() => {}}
                            />
                          </MenuItem>
                          <MenuItem>
                            <ReusuableSendaMailModal
                              displayName={result.userDetails.displayName}
                              id={result.id}
                              notificationStatus={
                                result.mainuserdata.notificationStatus
                              }
                            />
                          </MenuItem>
                        </>
                      ) : (
                        <>
                          <MenuItem>
                            <ReusuableReportDialogmodal
                              id={result.id}
                              param={"AskorSay"}
                            />
                          </MenuItem>
                          <MenuItem>
                            <ReusuableSendaMailModal
                              displayName={result.userDetails.displayName}
                              id={result.id}
                              notificationStatus={
                                result.mainuserdata.notificationStatus
                              }
                            />
                          </MenuItem>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <MenuItem
                        onClick={() => {
                          setEditID(result.id);
                          updateEditPostId(result.id);
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer" }}>
                          <img src={Edit} style={{ width: 18, height: 18, marginRight: 8, objectFit: "contain" }} alt="edit" />
                          <span style={{ fontSize: 14 }}>Edit Post</span>
                        </div>
                      </MenuItem>
                      <MenuItem>
                        <ReusuableDeleteDialogmodal
                          label={"Delete Post"}
                          type={props?.postType}
                          id={result.id}
                          deleteMessage={() =>
                            props?.onDelete && props.onDelete(result.id)
                          }
                          fetchContributors={() => {}}
                        />
                      </MenuItem>
                    </>
                  )}
                </Menu>
              </div>
            </div>
          </div>
          <>
            <div className={activityStyle.activityPostDescriptionContainer}>
              {editId === result?.id ? (
                <PostMessageValidation
                  id={result.id}
                  Message={result.Message}
                  messageType={"feedTextArea"}
                  filtertype={props?.filterType}
                  post={result}
                  onCloseEdit={cancelEdit}
                  onMessagedUpdated={updateMessage}
                  latitude={result.msgLat}
                  longitude={result.msgLng}
                  locationAddress={result.locName}
                  updateNewSelectedLocation={props?.updateNewSelectedLocation}
                  removeNewSelectedLocationKey={
                    props?.removeNewSelectedLocationKey
                  }
                  onDeleteAttachment={handleDeleteAttachementDoc}
                  isAttacmentDeleted={isAttacmentDeleted}
                  setIsAttacmentDeleted={setIsAttacmentDeleted}
                  docName={result?.docName}
                />
              ) : (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "baseline", // aligns with text bottom
                    flexWrap: "wrap",
                    gap: "5px", // small gap between text and file name
                  }}
                >
                  <Typography whiteSpace="pre-wrap">
                    <TextWithUrlsAndHashTags
                      Message={result.Message}
                      text={result.msg}
                      urls={result.url}
                      hashtags={result.tag}
                      tagActivityTenantId={
                        props?.filterType === "activityAnswer" ||
                        props?.filterType === "activityReply"
                          ? result.Tenant_ID
                          : undefined
                      }
                      onHashtagClick={props?.onHashTagClick}
                    />
                  </Typography>
                  <PostAttachmentViewer
                    docLocation={result.docLocation}
                    docTagged={result.docTagged}
                    docName={result.docName}
                    messageID={result.id}
                    activeTooltip={activeTooltip}
                    setActiveTooltip={setActiveTooltip}
                    onDeleteAttachment={handleDeleteAttachementDoc}
                  />
                </div>
              )}
            </div>
          </>

          {editId !== result?.id && (
            <>
            <div className="PostCounts">
            <div className={activityStyle.likeCountContainer}>
              {result.voteUp !== 0 ? (
                <SimpleDialogDemo
                  voteUp={result.voteUp}
                  id={result.id}
                  isVoteup={"true"}
                  isActionDisabled={props.isActionDisabled}
                />
              ) : (
                <p style={{ marginBottom: "0px" }}>
                  {result.voteUp === 1
                    ? `${result.voteUp} Like`
                    : `${result.voteUp} likes`}
                </p>
              )}

              {result.parentMessageType === "private" ||
              result.parentMessageType === "public" ? (
                <>
                  <BsDot className={activityStyle.dotIcon} />
                  <button
                    onClick={() =>
                      props?.onHashTagClick({
                        hashtag: result.hashTag,
                        tenantId: result.Tenant_ID,
                      })
                    }
                    className={activityStyle.likeCountContainerButton}
                    type="button"
                  >
                    {result.hashTag}
                  </button>
                </>
              ) : (
                <>
                  {result.parentMessageType === "" ? null : (
                    <>
                      <BsDot className={activityStyle.dotIcon} />
                      <button
                        onClick={(e) =>
                          handleClickHashTag(result.Parent_ID, result.id)
                        }
                        className={activityStyle.likeCountContainerButton}
                        type="button"
                      >
                        {result.parentMessageType}
                      </button>
                    </>
                  )}
                </>
              )}
            </div>
            {result.communityFollowStatus === 0 &&
              result.tenantType === "private" && (
                <p className="warning-msg-text">
                  This is a private Community, No action is permitted for non
                  member
                </p>
              )}
          </div>

          <div className="PostActions">
            <>
              <div
                style={{
                  cursor: "pointer",
                  // marginTop: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  style={{
                    textTransform: "none",
                    color: "#000",
                    border: "none",
                  }}
                  disabled={
                    result.communityFollowStatus === 0 &&
                    result.tenantType === "private"
                  }
                  variant="outlined"
                  startIcon={
                    result.UserLikeStatus === "Active" ? (
                      <img src={like} alt="Unlike" />
                    ) : (
                      <img src={unlike} alt="Like" />
                    )
                  }
                  onClick={() =>
                    result.UserLikeStatus === "Active"
                      ? onLikeUnlikeSelection(result.id, "cacheUpdate")
                      : null
                  }
                >
                  Like
                </Button>
              </div>
            </>
          </div>
          </>
        )}
        </div>
      ))}

      {open && popupPostId && (
        <PopupComponent
          popupData={popupData}
          setPopupData={setPopupData}
          followunfollow={followunfollow}
          open={open}
          onClose={onClosePopup}
          postId={popupPostId}
          deletePopupMessage={deletePopupMessage}
          filtertype="activityTag"
          postType={props?.postType}
        />
      )}
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
      {showUnfollowAlert && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)}
          type="warning"
          title="Are you sure you want to Unfollow?"
          acceptLabel="Yes"
          onAccept={() => {
            followunfollowCallback(
              showUnfollowAlert?.id,
              showUnfollowAlert?.followStatus,
              showUnfollowAlert?.followCount,
            );
            setShowUnfollowAlert(null);
          }}
        />
      )}
    </>
  );
}

export default SaysActivityUI;
